import { apiClient } from './client';

export interface NoticeRecord {
  id: string;
  refKey: string;
  boardId: string | null;
  title: string;
  state: string;
  loading: boolean;
  sticky: boolean;
  payload: Record<string, any>;
  createdAt: string;
  updatedAt: string;
}

class NoticeService {
  /**
   * Fetch all active notices for a board (board-scoped + global).
   */
  async fetchForBoard(boardId: string): Promise<NoticeRecord[]> {
    const response = await apiClient.get(`/boards/${boardId}/notices`);
    return response.data.data;
  }

  /**
   * Create or update a notice.
   */
  async upsert(boardId: string, data: { refKey: string; title: string; state?: string; loading?: boolean; sticky?: boolean; payload?: Record<string, any> }): Promise<NoticeRecord> {
    const response = await apiClient.post(`/boards/${boardId}/notices`, data);
    return response.data.data;
  }

  /**
   * Dismiss a notice by its refKey.
   */
  async dismiss(boardId: string, refKey: string): Promise<void> {
    await apiClient.delete(`/boards/${boardId}/notices/${encodeURIComponent(refKey)}`);
  }
}

export const noticeService = new NoticeService();
